import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import css from './SectionTalentHero.module.css';
import { SectionHeroTabs } from '../../../../util/enums';
import { Icons, SecondaryButton } from '../../../../components';
const HeroTabs = ({
  isOwnListing,
  isCurrentUserSubscriptionActive,
  talentPlusMaybe,
  activeTab,
  handleTabClick,
  editListingRedirect,
}) => {
  const tabs = [
    'Home',
    // ...(isOwnListing || isCurrentUserSubscriptionActive ? [SectionHeroTabs.TALENT_PLUS] : []),
    'Talent Plus',
    'Unlockable Content',
    ...(talentPlusMaybe ? [SectionHeroTabs.SUBCRIPTIONS] : []),
    SectionHeroTabs.NILFLUENCE_SCORE,
  ];

  return (
    <div className={classNames(css.contentHeroTabs, !isOwnListing ? css.ownListingTabs : null)}>
      <div className={css.tabs}>
        {tabs.map((tab, index) => (
          <span
            key={index}
            className={tab === activeTab ? css.active : ''}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      {isOwnListing && (
        <div className={css.editSec}>
          <SecondaryButton type="button" onClick={editListingRedirect}>
            <Icons name="pen" /> <FormattedMessage id="SectionHero.edit" />
          </SecondaryButton>
        </div>
      )}
    </div>
  );
};

export default HeroTabs;
